export const getRandom = (max: number) => {
  return Math.floor(Math.random() * (max + 1));
};
